// Plan tiers for CommConnect. Features are the source of truth (returned by the
// backend from /settings); this file holds the display metadata used in Settings.
export const PLAN_TIERS = [
  {
    id: "connect",
    label: "CONNECT",
    tagline: "Manage the request.",
    desc: "Core intake, approval, notifications, tracking, and request history.",
  },
  {
    id: "connectplus",
    label: "CONNECT+",
    tagline: "Manage the entire workflow.",
    desc: "Adds production management, assignments, scheduling, routing, and calendar visibility.",
    recommended: true,
  },
  {
    id: "pro",
    label: "CONNECT PRO",
    tagline: "Workflow + publishing + intelligence.",
    desc: "Adds publication builder, email-platform export, and advanced analytics.",
  },
  {
    id: "network",
    label: "CommConnect NETWORK",
    tagline: "Across the whole organization.",
    desc: "Multi-unit administration, central standards, and organization-wide reporting.",
  },
];

export const EMAIL_PROVIDERS = [
  { id: "brevo", label: "Brevo" },
  { id: "mailchimp", label: "Mailchimp" },
  { id: "sendgrid", label: "SendGrid" },
  { id: "constant_contact", label: "Constant Contact" },
  { id: "manual", label: "Manual / Copy HTML" },
];

export const PROVIDER_LABELS = EMAIL_PROVIDERS.reduce((a, p) => ({ ...a, [p.id]: p.label }), {});

// Default features assume the top self-serve tier (pro) so nothing flickers/hides
// for the AEGO chapter (which runs on PRO) before /settings resolves.
export const DEFAULT_FEATURES = {
  production_dashboard: true,
  assignments: true,
  calendar: true,
  publication_builder: true,
  advanced_reports: true,
  email_export: true,
  multi_unit: false,
};
